import { UPDATE_OVERVIEW_FORM, CHANGE_TAB } from '../constant/ActionType';

let initialState = {
  overview: {},
  activeTab: ""
};

function lmsReducer(state = initialState, action) {

  switch (action.type) {
    case UPDATE_OVERVIEW_FORM:
      return {
        ...state,
        overview: {
          ...action.payload
        }
      }
    case CHANGE_TAB:
      return {
        ...state,
        activeTab: action.payload
      }
      break;
    default:
      return state;
      break;
  }
};

export default lmsReducer;
